import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class KPIService {
  async getKPIDashboard({
    startDate,
    endDate,
    departmentId,
    empId,
  }) {
    const params = qs.stringify({
      ...(startDate && { startDate }),
      ...(endDate && { endDate }),
      ...(departmentId && { departmentId }),
      ...(empId && { empId }),
    });
    try {
      const response = await HttpClient.get(`/api/kpi/dashboard?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getKPIDashboardDetail({
    stepKPIID,
    startDate,
    endDate,
    departmentId,
    empId,
  }) {
    const params = qs.stringify({
      ...(stepKPIID && { stepKPIID }),
      ...(startDate && { startDate }),
      ...(endDate && { endDate }),
      ...(departmentId && { departmentId }),
      ...(empId && { empId }),
    });

    try {
      const response = await HttpClient.get(`/api/kpi/dashboard/detail?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getKPIDocumentLog(draftId) {
    try {
      const response = await HttpClient.get(`/api/kpi/smartfrom/log?draftId=${draftId}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new KPIService();
